export const CHAT_INITIAL_WINDOW_DAYS = 3;
export const CHAT_LIST_PAGE_SIZE = 13;
export const MESSAGE_INITIAL_PAGE_SIZE = 15;
export const NEWER_MESSAGES_PAGE_SIZE = 50;
export const ROOM_CACHE_TTL_MS = 5 * 60 * 1000;
export const CHAT_ENTITY_CACHE_TTL_MS = 30 * 60 * 1000;
